import React, {Component} from 'react';

import Menu from '../Components/Menu';
class   Blank extends React.Component {
  render() {
return <div class="nk-content ">
                    <div class="container wide-xl">
                        <div class="nk-content-inner">
                            <div class="nk-aside" data-content="sideNav" data-toggle-overlay="true" data-toggle-screen="lg" data-toggle-body="true">
                                <Menu/>
                                
                                
                                {/* <!-- .nk-sidebar-menu --> */}
                                <div className="nk-aside-close">
                                    <a href="#" className="toggle" data-target="sideNav"><em className="icon ni ni-cross"></em></a>
                                </div>{/* <!-- .nk-aside-close --> */}
                            </div>{/* <!-- .nk-aside --> */}
                            <div className="nk-content-body">
                                <div className="nk-content-wrap">
                                    <p>Blank Layout for Subscription Panel</p>
                                </div>
                            
                            </div>
                        </div>
                    </div>
                </div>
}
}
export default Blank;